import { MutationCache } from "@tanstack/react-query";
import { toast } from "sonner";

/**
 * Global fail-loudly net: any mutation that fails without its own hook-level
 * onError surfaces a visible error toast. Mutations with a hook-level
 * handler behave exactly as before — the guard prevents a double-toast,
 * since react-query fires the MutationCache handler in ADDITION to the
 * mutation's own onError, never instead of it.
 *
 * KNOWN LIMITATION: the guard only sees `mutation.options.onError`, i.e. the
 * handler passed to useMutation() itself. A per-call `mutate(vars, {onError})`
 * callback is stored in MutationObserver's private #mutateOptions (verified
 * in react-query 5.90.7) and is not reachable from MutationCache — so it
 * cannot be detected here. A hook with no hook-level onError whose call
 * sites pass their own onError will double-toast until that onError is
 * moved onto the useMutation() definition (the eslint ratchet's grandfather
 * list is exactly the set of hooks still needing this migration).
 */
export function createMutationErrorNet(): MutationCache {
  return new MutationCache({
    onError: (error, _vars, _ctx, mutation) => {
      if (mutation.options.onError) return;
      toast.error(error instanceof Error ? error.message : "Er ging iets mis — actie niet opgeslagen");
    },
  });
}
